import React from 'react';
import cx from 'classnames';
import s from './index.module.css';

import ExpertChatHistory from '../../ExpertChatHistory';
import Scroll from '../../Scroll';

const LayoutLeft = ({ className }) => {
    return (
        <div className={cx(className, s.leftSideInfo)}>
            <Scroll>
                <ExpertChatHistory />
            </Scroll>
        </div>
    )
};

export default LayoutLeft;

